module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_2.d839bd10.png";